import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV, faChartBar } from "@fortawesome/free-solid-svg-icons";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import { BodyAsFormData } from "../../services/utilities/util";
import FilterContext from "../../routes/FilterContext";
import { apiTopOfficeProjects } from "../../services/apis/retail/apiTopOfficeProjects";

class TopOfficeProjects extends React.Component {
  static contextType = FilterContext;

  state = {
    topOfficeProjects: [],
  };

  // componentDidMount() {
  //     apiTopOfficeProjects.post(BodyAsFormData(filters)).then((res) => {
  //         this.setState({ topOfficeProjects: res.data });
  //     });
  // }

  render() {
    return (
      <div className="col-lg-6">
        <div className="widget widgetTable">
          <div className="row">
            <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
              <p>Top Ofﬁce Projects</p>
            </div>
            <div className="col-lg-3 text-end">
              {/* <Link to="/#" className="pe-3">
                                <FontAwesomeIcon icon={faChartBar} />
                            </Link>
                            <Link to="/#" className="colorBlack">
                                <FontAwesomeIcon icon={faEllipsisV} />
                            </Link> */}
            </div>
            <div className="col-lg-12 mt-2">
              <Table responsive hover>
                <thead>
                  <tr className="tableTdColor">
                    <th>Asset</th>
                    <th>Occupancy</th>
                    <th>Passing Rent</th>
                    <th>Market Rent.</th>
                    <th>WALE</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.topOfficeProjects.map((row, i) => (
                    <tr className="tableTdColor" key={i}>
                      <td>{row.complex}</td>
                      <td>{row.occupancy}%</td>
                      <td>{row.passing_rent}</td>
                      <td>{row.rent}</td>
                      <td>{row.wale}</td>
                    </tr>
                  ))}
                  {/* <tr className="tableTdColor">
                            <td>DLF Park</td>
                            <td>92%</td>
                            <td>109</td>
                            <td>123</td>
                            <td>63.5</td>
                          </tr>
                          <tr className="tableTdColor">
                            <td>DLF Park</td>
                            <td>92%</td>
                            <td>109</td>
                            <td>123</td>
                            <td>63.5</td>
                          </tr>
                          <tr className="tableTdColor">
                            <td>DLF Park</td>
                            <td>92%</td>
                            <td>109</td>
                            <td>123</td>
                            <td>63.5</td>
                          </tr>
                          <tr className="tableTdColor">
                            <td>DLF Park</td>
                            <td>92%</td>
                            <td>109</td>
                            <td>123</td>
                            <td>63.5</td>
                          </tr>
                          <tr className="tableTdColor">
                            <td>DLF Park</td>
                            <td>92%</td>
                            <td>109</td>
                            <td>123</td>
                            <td>63.5</td>
                          </tr> */}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TopOfficeProjects;
